import { gql } from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: any; output: any; }
  JsonBlob: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

/**
 * Represents the relationship between a user and their agency/contractor organizations,
 * including organization and role information for both agency and contractor associations.
 */
export type AgencyContractorUserLink = {
  agencyOrgCode?: Maybe<Scalars['String']['output']>;
  agencyOrgId?: Maybe<Scalars['UUID']['output']>;
  agencyOrgName?: Maybe<Scalars['String']['output']>;
  agencyRoles?: Maybe<Array<AgencyOrgRoleInfo>>;
  agencyUserInOrgId?: Maybe<Scalars['UUID']['output']>;
  contractorOrgCode?: Maybe<Scalars['String']['output']>;
  contractorOrgId?: Maybe<Scalars['UUID']['output']>;
  contractorOrgName?: Maybe<Scalars['String']['output']>;
  contractorUserInOrgId?: Maybe<Scalars['UUID']['output']>;
  userId: Scalars['UUID']['output'];
};

/**
 * Represents information about an agency organization role associated with a user,
 * including role identifiers, names, claim prefixes, and validity dates.
 */
export type AgencyOrgRoleInfo = {
  roleOrgId: Scalars['UUID']['output'];
  serviceRoleClaimPrefix?: Maybe<Scalars['String']['output']>;
  serviceRoleDateExpire?: Maybe<Scalars['DateTime']['output']>;
  serviceRoleDateStart?: Maybe<Scalars['DateTime']['output']>;
  serviceRoleId: Scalars['UUID']['output'];
  serviceRoleName?: Maybe<Scalars['String']['output']>;
  userOrgsInOrgRolesID: Scalars['UUID']['output'];
};

/** A connection to a list of items. */
export type ApplicationAccountsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<ApplicationAccountsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserOrganizationInOrganizationRole>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ApplicationAccountsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserOrganizationInOrganizationRole;
};

export type ApplicationService = {
  claimPrefix?: Maybe<Scalars['String']['output']>;
  dateCreated: Scalars['DateTime']['output'];
  dateExpire?: Maybe<Scalars['DateTime']['output']>;
  dateStart?: Maybe<Scalars['DateTime']['output']>;
  homePageLink?: Maybe<HomePageLink>;
  homePageLinkId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  orgInServices?: Maybe<Array<Maybe<OrganizationInService>>>;
};

/** A connection to a list of items. */
export type ApplicationServiceByEnumConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<ApplicationServiceByEnumEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ApplicationService>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ApplicationServiceByEnumEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ApplicationService;
};

export type ApplicationServiceFilterInput = {
  and?: InputMaybe<Array<ApplicationServiceFilterInput>>;
  claimPrefix?: InputMaybe<StringOperationFilterInput>;
  dateCreated?: InputMaybe<DateTimeOperationFilterInput>;
  dateExpire?: InputMaybe<DateTimeOperationFilterInput>;
  dateStart?: InputMaybe<DateTimeOperationFilterInput>;
  homePageLink?: InputMaybe<HomePageLinkFilterInput>;
  homePageLinkId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ApplicationServiceFilterInput>>;
  orgInServices?: InputMaybe<ListFilterInputTypeOfOrganizationInServiceFilterInput>;
};

export type ApplicationServiceSortInput = {
  claimPrefix?: InputMaybe<SortEnumType>;
  dateCreated?: InputMaybe<SortEnumType>;
  dateExpire?: InputMaybe<SortEnumType>;
  dateStart?: InputMaybe<SortEnumType>;
  homePageLink?: InputMaybe<HomePageLinkSortInput>;
  homePageLinkId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ApplicationServicesConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<ApplicationServicesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ApplicationService>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type ApplicationServicesContainsNameConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<ApplicationServicesContainsNameEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ApplicationService>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ApplicationServicesContainsNameEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ApplicationService;
};

/** An edge in a connection. */
export type ApplicationServicesEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ApplicationService;
};

/** Enum representing application services. */
export enum ApplicationServicesEnum {
  ActiveInsights = 'ACTIVE_INSIGHTS',
  CaseManager = 'CASE_MANAGER',
  DailyReporter = 'DAILY_REPORTER',
  LcpCertified = 'LCP_CERTIFIED',
  LcpTrackerProfessional = 'LCP_TRACKER_PROFESSIONAL',
  UserPortal = 'USER_PORTAL',
  WorkforceManager = 'WORKFORCE_MANAGER'
}

/** Input model for ApplicationService */
export type ApplicationServicesInputModelInput = {
  /** Gets or sets the claim prefix. */
  claimPrefix: Scalars['String']['input'];
  /** Gets or sets the date expire. */
  dateExpire?: InputMaybe<Scalars['DateTime']['input']>;
  /** Gets or sets the date start. */
  dateStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Gets or sets the homepage link id. */
  homePageLinkId?: InputMaybe<Scalars['UUID']['input']>;
  /** Gets or sets the name of the org. */
  name: Scalars['String']['input'];
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

export type BoolResultModel = {
  data: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  meta: Array<KeyValuePairOfStringAndObject>;
  status: Scalars['Int']['output'];
  unhandledException?: Maybe<Scalars['String']['output']>;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Claim = {
  dateCreated: Scalars['DateTime']['output'];
  dateExpire?: Maybe<Scalars['DateTime']['output']>;
  dateStart?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isPublic: Scalars['Boolean']['output'];
  key?: Maybe<Scalars['String']['output']>;
  parentId: Scalars['UUID']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ClaimFilterInput = {
  and?: InputMaybe<Array<ClaimFilterInput>>;
  dateCreated?: InputMaybe<DateTimeOperationFilterInput>;
  dateExpire?: InputMaybe<DateTimeOperationFilterInput>;
  dateStart?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isPublic?: InputMaybe<BooleanOperationFilterInput>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ClaimFilterInput>>;
  parentId?: InputMaybe<UuidOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type ClaimSortInput = {
  dateCreated?: InputMaybe<SortEnumType>;
  dateExpire?: InputMaybe<SortEnumType>;
  dateStart?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isPublic?: InputMaybe<SortEnumType>;
  key?: InputMaybe<SortEnumType>;
  parentId?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ClaimsByParentIdConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<ClaimsByParentIdEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Claim>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ClaimsByParentIdEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Claim;
};

/** A connection to a list of items. */
export type ClaimsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<ClaimsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Claim>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ClaimsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Claim;
};

/** Input for Claims model */
export type ClaimsInputModelInput = {
  /** Gets the date expire. */
  dateExpire?: InputMaybe<Scalars['DateTime']['input']>;
  /** Gets the date start. */
  dateStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Gets a value indicating whether is public. */
  isPublic: Scalars['Boolean']['input'];
  /** Gets the key. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Gets the parent id. */
  parentId: Scalars['UUID']['input'];
  /** Gets the value. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Represents the success indicator
 * of the Completion operation.
 */
export type CompletedSuccess = {
  completed: Scalars['Boolean']['output'];
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeleteSuccess = {
  deleted: Scalars['Boolean']['output'];
};

/** A connection to a list of items. */
export type DeprecationClaimsByUserIdConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<DeprecationClaimsByUserIdEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Claim>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeprecationClaimsByUserIdEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Claim;
};

/** Represents the input model for deprecation rules. */
export type DeprecationRuleInputModelInput = {
  /** Primary Contact like the IT ADMIN {LastName, Firstname} */
  contactName: Scalars['String']['input'];
  /** Gets or sets the soft delete period in days. */
  disconnect?: InputMaybe<Scalars['Int']['input']>;
  /** Gets or sets a value indicating whether staff is excluded. */
  excludeStaff?: InputMaybe<Scalars['Boolean']['input']>;
  /** Gets or sets a value indicating whether auto expiration is active. */
  isAutoExpirationActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Primary UserEmail like the IT ADMIN */
  primaryEmail: Scalars['String']['input'];
  /** Gets or sets the hard delete period in days. */
  softDelete?: InputMaybe<Scalars['Int']['input']>;
  /** Gets or sets the warning period in days. */
  warning?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents information about a user and their organization. */
export type DeprecationUserData = {
  /** Gets or sets the deprecation rule type. */
  deprecationRuleType: Scalars['String']['output'];
  /** Gets or sets the organization name. */
  orgName: Scalars['String']['output'];
  /** Gets or sets the organization ID. */
  orgid: Scalars['UUID']['output'];
  /** Primary UserEmail like the IT ADMIN */
  primaryEmail: Scalars['String']['output'];
  /** Primary Contact like the IT ADMIN {LastName, Firstname} */
  primaryName: Scalars['String']['output'];
  /** Gets or sets the email of the user. */
  userEmail: Scalars['String']['output'];
  /** Gets or sets the user ID. */
  userId: Scalars['UUID']['output'];
  /** Gets or sets the username of the user. */
  userName: Scalars['String']['output'];
};

export type EditLog = {
  changeDate: Scalars['DateTime']['output'];
  changedById: Scalars['UUID']['output'];
  changedVia?: Maybe<Scalars['String']['output']>;
  fieldsChanged?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  rowNumber: Scalars['Int']['output'];
  userId: Scalars['UUID']['output'];
};

/** The edit log in put model. */
export type EditLogInPutModelInput = {
  /** Gets or sets the changed by identifier of the support staff that is making the changes. */
  changedById: Scalars['UUID']['input'];
  /**
   * Gets or sets the changed via. Currently the value should be "Support Console".
   * Later as we add tools for other users being able to make changes, we will add their names too.
   */
  changedVia: Scalars['String']['input'];
  /**
   * Gets or sets the fields changed.This is a comma delimited list of field names being changed.
   * Max length is 2048 characters.
   */
  fieldsChanged: Scalars['String']['input'];
  /** Gets or sets the customer's user record identifier. */
  userId: Scalars['UUID']['input'];
};

/** A connection to a list of items. */
export type EditLogsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<EditLogsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EditResultsModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EditLogsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EditResultsModel;
};

/** The edit resultsmodel. */
export type EditResultsModel = {
  /** Gets or sets the change date. */
  changeDate: Scalars['DateTime']['output'];
  /** Gets or sets the changed by user name. */
  changedByUserName: Scalars['String']['output'];
  /** Gets or sets the changed via. */
  changedVia: Scalars['String']['output'];
  /** Gets or sets the fields changed. */
  fieldsChanged: Scalars['String']['output'];
  /** Gets or sets the id. */
  id: Scalars['UUID']['output'];
  /** Gets or sets the row number. */
  rowNumber: Scalars['Int']['output'];
  /** Gets or sets the user id. */
  userId: Scalars['UUID']['output'];
  /** Gets or sets the user name. */
  userName: Scalars['String']['output'];
};

/** The edit resultsmodel. */
export type EditResultsModelFilterInput = {
  and?: InputMaybe<Array<EditResultsModelFilterInput>>;
  /** Gets or sets the change date. */
  changeDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets or sets the changed by user name. */
  changedByUserName?: InputMaybe<StringOperationFilterInput>;
  /** Gets or sets the changed via. */
  changedVia?: InputMaybe<StringOperationFilterInput>;
  /** Gets or sets the fields changed. */
  fieldsChanged?: InputMaybe<StringOperationFilterInput>;
  /** Gets or sets the id. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<EditResultsModelFilterInput>>;
  /** Gets or sets the row number. */
  rowNumber?: InputMaybe<IntOperationFilterInput>;
  /** Gets or sets the user id. */
  userId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the user name. */
  userName?: InputMaybe<StringOperationFilterInput>;
};

/** The edit resultsmodel. */
export type EditResultsModelSortInput = {
  /** Gets or sets the change date. */
  changeDate?: InputMaybe<SortEnumType>;
  /** Gets or sets the changed by user name. */
  changedByUserName?: InputMaybe<SortEnumType>;
  /** Gets or sets the changed via. */
  changedVia?: InputMaybe<SortEnumType>;
  /** Gets or sets the fields changed. */
  fieldsChanged?: InputMaybe<SortEnumType>;
  /** Gets or sets the id. */
  id?: InputMaybe<SortEnumType>;
  /** Gets or sets the row number. */
  rowNumber?: InputMaybe<SortEnumType>;
  /** Gets or sets the user id. */
  userId?: InputMaybe<SortEnumType>;
  /** Gets or sets the user name. */
  userName?: InputMaybe<SortEnumType>;
};

export type Error = {
  extensions?: Maybe<ErrorExtensions>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorExtensions = {
  attemptedValue?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  propertyName?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
};

export type ExternalClaimTransformation = {
  asMultipleValues: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  fromClaimType: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  scheme: Scalars['String']['output'];
  toClaimType: Scalars['String']['output'];
};

export type ExternalClaimTransformationFilterInput = {
  and?: InputMaybe<Array<ExternalClaimTransformationFilterInput>>;
  asMultipleValues?: InputMaybe<BooleanOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  fromClaimType?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  modifiedAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ExternalClaimTransformationFilterInput>>;
  scheme?: InputMaybe<StringOperationFilterInput>;
  toClaimType?: InputMaybe<StringOperationFilterInput>;
};

export type ExternalProvider = {
  claimTransformations?: Maybe<Array<Maybe<ExternalClaimTransformation>>>;
  createdAt: Scalars['DateTime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kindName?: Maybe<Scalars['String']['output']>;
  mapDefaultOutboundClaimType: Scalars['Boolean']['output'];
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  serializedHandlerType?: Maybe<Scalars['String']['output']>;
  serializedOptions?: Maybe<Scalars['String']['output']>;
  storeClaims: Scalars['Boolean']['output'];
};

export type ExternalProviderFilterInput = {
  and?: InputMaybe<Array<ExternalProviderFilterInput>>;
  claimTransformations?: InputMaybe<ListFilterInputTypeOfExternalClaimTransformationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  kindName?: InputMaybe<StringOperationFilterInput>;
  mapDefaultOutboundClaimType?: InputMaybe<BooleanOperationFilterInput>;
  modifiedAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ExternalProviderFilterInput>>;
  serializedHandlerType?: InputMaybe<StringOperationFilterInput>;
  serializedOptions?: InputMaybe<StringOperationFilterInput>;
  storeClaims?: InputMaybe<BooleanOperationFilterInput>;
};

export type ExternalProviderSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  displayName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  kindName?: InputMaybe<SortEnumType>;
  mapDefaultOutboundClaimType?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  serializedHandlerType?: InputMaybe<SortEnumType>;
  serializedOptions?: InputMaybe<SortEnumType>;
  storeClaims?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type FindAllSoftDeletedUsersConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<FindAllSoftDeletedUsersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FindAllSoftDeletedUsersEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: User;
};

export type GuidResultsModel = {
  data: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  meta: Array<KeyValuePairOfStringAndObject>;
  status: Scalars['Int']['output'];
  unhandledException?: Maybe<Scalars['String']['output']>;
};

export type HomePageLink = {
  applicationServices?: Maybe<Array<Maybe<ApplicationService>>>;
  className?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isPublicLink: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  requireAuth: Scalars['Boolean']['output'];
  requireMfa: Scalars['Boolean']['output'];
  staffOnly: Scalars['Boolean']['output'];
  uri?: Maybe<Scalars['String']['output']>;
};

export type HomePageLinkFilterInput = {
  and?: InputMaybe<Array<HomePageLinkFilterInput>>;
  applicationServices?: InputMaybe<ListFilterInputTypeOfApplicationServiceFilterInput>;
  className?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  isPublicLink?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<HomePageLinkFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  requireAuth?: InputMaybe<BooleanOperationFilterInput>;
  requireMfa?: InputMaybe<BooleanOperationFilterInput>;
  staffOnly?: InputMaybe<BooleanOperationFilterInput>;
  uri?: InputMaybe<StringOperationFilterInput>;
};

export type HomePageLinkSortInput = {
  className?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  isPublicLink?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  order?: InputMaybe<SortEnumType>;
  requireAuth?: InputMaybe<SortEnumType>;
  requireMfa?: InputMaybe<SortEnumType>;
  staffOnly?: InputMaybe<SortEnumType>;
  uri?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type HomePageLinksConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<HomePageLinksEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<HomePageLink>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type HomePageLinksEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HomePageLink;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type KeyValuePairOfStringAndObject = {
  key: Scalars['String']['output'];
};

export type KeyValuePairOfStringAndString = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ListFilterInputTypeOfApplicationServiceFilterInput = {
  all?: InputMaybe<ApplicationServiceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ApplicationServiceFilterInput>;
  some?: InputMaybe<ApplicationServiceFilterInput>;
};

export type ListFilterInputTypeOfExternalClaimTransformationFilterInput = {
  all?: InputMaybe<ExternalClaimTransformationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ExternalClaimTransformationFilterInput>;
  some?: InputMaybe<ExternalClaimTransformationFilterInput>;
};

export type ListFilterInputTypeOfOrganizationInOrganizationFilterInput = {
  all?: InputMaybe<OrganizationInOrganizationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrganizationInOrganizationFilterInput>;
  some?: InputMaybe<OrganizationInOrganizationFilterInput>;
};

export type ListFilterInputTypeOfOrganizationInRoleFilterInput = {
  all?: InputMaybe<OrganizationInRoleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrganizationInRoleFilterInput>;
  some?: InputMaybe<OrganizationInRoleFilterInput>;
};

export type ListFilterInputTypeOfOrganizationInServiceFilterInput = {
  all?: InputMaybe<OrganizationInServiceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrganizationInServiceFilterInput>;
  some?: InputMaybe<OrganizationInServiceFilterInput>;
};

export type ListFilterInputTypeOfServiceRoleFilterInput = {
  all?: InputMaybe<ServiceRoleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ServiceRoleFilterInput>;
  some?: InputMaybe<ServiceRoleFilterInput>;
};

export type ListFilterInputTypeOfUserInOrganizationFilterInput = {
  all?: InputMaybe<UserInOrganizationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UserInOrganizationFilterInput>;
  some?: InputMaybe<UserInOrganizationFilterInput>;
};

export type ListFilterInputTypeOfUserOrganizationInOrganizationRoleFilterInput = {
  all?: InputMaybe<UserOrganizationInOrganizationRoleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UserOrganizationInOrganizationRoleFilterInput>;
  some?: InputMaybe<UserOrganizationInOrganizationRoleFilterInput>;
};

export enum ManagementPrivileges {
  Assign = 'ASSIGN',
  Edit = 'EDIT',
  Manage = 'MANAGE',
  None = 'NONE',
  View = 'VIEW'
}

export type ManagementPrivilegesOperationFilterInput = {
  eq?: InputMaybe<ManagementPrivileges>;
  in?: InputMaybe<Array<ManagementPrivileges>>;
  neq?: InputMaybe<ManagementPrivileges>;
  nin?: InputMaybe<Array<ManagementPrivileges>>;
};

export type NullableOfOrgTypesOperationFilterInput = {
  eq?: InputMaybe<OrgTypes>;
  in?: InputMaybe<Array<InputMaybe<OrgTypes>>>;
  neq?: InputMaybe<OrgTypes>;
  nin?: InputMaybe<Array<InputMaybe<OrgTypes>>>;
};

/** A connection to a list of items. */
export type OrgInRoleConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<OrgInRoleEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OrganizationInRole>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrgInRoleEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OrganizationInRole;
};

/** Input for Org In Role model */
export type OrgInRoleInputModelInput = {
  /** Gets or sets the claim prefix */
  claimPrefix: Scalars['String']['input'];
  /** Gets or Sets the date expire. */
  dateExpire?: InputMaybe<Scalars['DateTime']['input']>;
  /** Gets or Sets the date start. */
  dateStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Gets or Sets the org id. */
  orgId: Scalars['UUID']['input'];
  /** Gets or Sets the org in service id. */
  orgInServiceId: Scalars['UUID']['input'];
  /** Gets or Sets the service role id. */
  serviceRoleId: Scalars['UUID']['input'];
};

/** A connection to a list of items. */
export type OrgInServicesConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<OrgInServicesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OrganizationInService>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrgInServicesEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OrganizationInService;
};

/** Input for Services Roles model */
export type OrgInServicesInputModelInput = {
  /** Gets or sets the claim prefix */
  claimPrefix: Scalars['String']['input'];
  /** Gets or Sets the date expire. */
  dateExpire?: InputMaybe<Scalars['DateTime']['input']>;
  /** Gets or Sets the date start. */
  dateStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Gets or Sets the org id. */
  orgId: Scalars['UUID']['input'];
  /** Gets or Sets the service id. */
  serviceId: Scalars['UUID']['input'];
};

export enum OrgTpaRule {
  AdminsOnly = 'ADMINS_ONLY',
  AllJediMustDie = 'ALL_JEDI_MUST_DIE',
  Everyone = 'EVERYONE',
  NoEnforcement = 'NO_ENFORCEMENT',
  TpaOrMfaFilterOnEmailDomain = 'TPA_OR_MFA_FILTER_ON_EMAIL_DOMAIN'
}

export type OrgTpaRuleOperationFilterInput = {
  eq?: InputMaybe<OrgTpaRule>;
  in?: InputMaybe<Array<OrgTpaRule>>;
  neq?: InputMaybe<OrgTpaRule>;
  nin?: InputMaybe<Array<OrgTpaRule>>;
};

export enum OrgTypes {
  Agency = 'AGENCY',
  Contractor = 'CONTRACTOR',
  Federal = 'FEDERAL',
  Military = 'MILITARY',
  Prime = 'PRIME',
  Rehabilitation = 'REHABILITATION',
  State = 'STATE',
  Training = 'TRAINING'
}

export type Organization = {
  childOrgs?: Maybe<Array<Maybe<OrganizationInOrganization>>>;
  claimPrefix?: Maybe<Scalars['String']['output']>;
  dateCreated: Scalars['DateTime']['output'];
  dateExpire?: Maybe<Scalars['DateTime']['output']>;
  dateStart?: Maybe<Scalars['DateTime']['output']>;
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  orgCode?: Maybe<Scalars['String']['output']>;
  orgName?: Maybe<Scalars['String']['output']>;
  orgType: OrgTypes;
  orgUsers?: Maybe<Array<Maybe<UserInOrganization>>>;
  orgsInServices?: Maybe<Array<Maybe<OrganizationInService>>>;
  parentOrgs?: Maybe<Array<Maybe<OrganizationInOrganization>>>;
  requireMFA: Scalars['Boolean']['output'];
  tpaRule: OrgTpaRule;
  tpaRuleFilter?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type OrganizationContainsOrgNameConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<OrganizationContainsOrgNameEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Organization>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganizationContainsOrgNameEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Organization;
};

export type OrganizationFilterInput = {
  and?: InputMaybe<Array<OrganizationFilterInput>>;
  childOrgs?: InputMaybe<ListFilterInputTypeOfOrganizationInOrganizationFilterInput>;
  claimPrefix?: InputMaybe<StringOperationFilterInput>;
  dateCreated?: InputMaybe<DateTimeOperationFilterInput>;
  dateExpire?: InputMaybe<DateTimeOperationFilterInput>;
  dateStart?: InputMaybe<DateTimeOperationFilterInput>;
  dateUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<OrganizationFilterInput>>;
  orgCode?: InputMaybe<StringOperationFilterInput>;
  orgName?: InputMaybe<StringOperationFilterInput>;
  orgType?: InputMaybe<NullableOfOrgTypesOperationFilterInput>;
  orgUsers?: InputMaybe<ListFilterInputTypeOfUserInOrganizationFilterInput>;
  orgsInServices?: InputMaybe<ListFilterInputTypeOfOrganizationInServiceFilterInput>;
  parentOrgs?: InputMaybe<ListFilterInputTypeOfOrganizationInOrganizationFilterInput>;
  requireMFA?: InputMaybe<BooleanOperationFilterInput>;
  tpaRule?: InputMaybe<OrgTpaRuleOperationFilterInput>;
  tpaRuleFilter?: InputMaybe<StringOperationFilterInput>;
};

export type OrganizationInOrganization = {
  childOrg?: Maybe<Organization>;
  childOrgId?: Maybe<Scalars['UUID']['output']>;
  claimPrefix?: Maybe<Scalars['String']['output']>;
  dateCreated: Scalars['DateTime']['output'];
  dateExpire?: Maybe<Scalars['DateTime']['output']>;
  dateStart?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  managementPrivilege: ManagementPrivileges;
  parentOrg?: Maybe<Organization>;
  parentOrgId?: Maybe<Scalars['UUID']['output']>;
};

/** A connection to a list of items. */
export type OrganizationInOrganizationConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<OrganizationInOrganizationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OrganizationInOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganizationInOrganizationEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OrganizationInOrganization;
};

export type OrganizationInOrganizationFilterInput = {
  and?: InputMaybe<Array<OrganizationInOrganizationFilterInput>>;
  childOrg?: InputMaybe<OrganizationFilterInput>;
  childOrgId?: InputMaybe<UuidOperationFilterInput>;
  claimPrefix?: InputMaybe<StringOperationFilterInput>;
  dateCreated?: InputMaybe<DateTimeOperationFilterInput>;
  dateExpire?: InputMaybe<DateTimeOperationFilterInput>;
  dateStart?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  managementPrivilege?: InputMaybe<ManagementPrivilegesOperationFilterInput>;
  or?: InputMaybe<Array<OrganizationInOrganizationFilterInput>>;
  parentOrg?: InputMaybe<OrganizationFilterInput>;
  parentOrgId?: InputMaybe<UuidOperationFilterInput>;
};

/** Input model for Organization in Organization. */
export type OrganizationInOrganizationInputModelInput = {
  /** Gets or sets the child organization's id. */
  childOrganizationId: Scalars['UUID']['input'];
  /** Gets or sets the claim prefix. */
  claimPrefix: Scalars['String']['input'];
  /** Gets or sets the date when this association expires. */
  dateExpire?: InputMaybe<Scalars['DateTime']['input']>;
  /** Gets or sets the date when this association starts. */
  dateStart?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Gets or sets the ManagementPrivileges
   * Management Privileges of this record.
   */
  managementPrivilege: ManagementPrivileges;
  /** Gets or sets the parent organization's id. */
  parentOrganizationId: Scalars['UUID']['input'];
};

export type OrganizationInOrganizationSortInput = {
  childOrg?: InputMaybe<OrganizationSortInput>;
  childOrgId?: InputMaybe<SortEnumType>;
  claimPrefix?: InputMaybe<SortEnumType>;
  dateCreated?: InputMaybe<SortEnumType>;
  dateExpire?: InputMaybe<SortEnumType>;
  dateStart?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  managementPrivilege?: InputMaybe<SortEnumType>;
  parentOrg?: InputMaybe<OrganizationSortInput>;
  parentOrgId?: InputMaybe<SortEnumType>;
};

export type OrganizationInRole = {
  claimPrefix?: Maybe<Scalars['String']['output']>;
  dateCreated: Scalars['DateTime']['output'];
  dateExpire?: Maybe<Scalars['DateTime']['output']>;
  dateStart?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  orgId: Scalars['UUID']['output'];
  orgInServiceId: Scalars['UUID']['output'];
  orgService?: Maybe<OrganizationInService>;
  orgUsersForOrgRole?: Maybe<Array<Maybe<UserOrganizationInOrganizationRole>>>;
  serviceRole?: Maybe<ServiceRole>;
  serviceRoleId: Scalars['UUID']['output'];
};

export type OrganizationInRoleFilterInput = {
  and?: InputMaybe<Array<OrganizationInRoleFilterInput>>;
  claimPrefix?: InputMaybe<StringOperationFilterInput>;
  dateCreated?: InputMaybe<DateTimeOperationFilterInput>;
  dateExpire?: InputMaybe<DateTimeOperationFilterInput>;
  dateStart?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<OrganizationInRoleFilterInput>>;
  orgId?: InputMaybe<UuidOperationFilterInput>;
  orgInServiceId?: InputMaybe<UuidOperationFilterInput>;
  orgService?: InputMaybe<OrganizationInServiceFilterInput>;
  orgUsersForOrgRole?: InputMaybe<ListFilterInputTypeOfUserOrganizationInOrganizationRoleFilterInput>;
  serviceRole?: InputMaybe<ServiceRoleFilterInput>;
  serviceRoleId?: InputMaybe<UuidOperationFilterInput>;
};

export type OrganizationInRoleSortInput = {
  claimPrefix?: InputMaybe<SortEnumType>;
  dateCreated?: InputMaybe<SortEnumType>;
  dateExpire?: InputMaybe<SortEnumType>;
  dateStart?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  orgId?: InputMaybe<SortEnumType>;
  orgInServiceId?: InputMaybe<SortEnumType>;
  orgService?: InputMaybe<OrganizationInServiceSortInput>;
  serviceRole?: InputMaybe<ServiceRoleSortInput>;
  serviceRoleId?: InputMaybe<SortEnumType>;
};

export type OrganizationInService = {
  claimPrefix?: Maybe<Scalars['String']['output']>;
  dateCreated: Scalars['DateTime']['output'];
  dateExpire?: Maybe<Scalars['DateTime']['output']>;
  dateStart?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  org?: Maybe<Organization>;
  orgId: Scalars['UUID']['output'];
  service?: Maybe<ApplicationService>;
  serviceId: Scalars['UUID']['output'];
};

export type OrganizationInServiceFilterInput = {
  and?: InputMaybe<Array<OrganizationInServiceFilterInput>>;
  claimPrefix?: InputMaybe<StringOperationFilterInput>;
  dateCreated?: InputMaybe<DateTimeOperationFilterInput>;
  dateExpire?: InputMaybe<DateTimeOperationFilterInput>;
  dateStart?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<OrganizationInServiceFilterInput>>;
  org?: InputMaybe<OrganizationFilterInput>;
  orgId?: InputMaybe<UuidOperationFilterInput>;
  service?: InputMaybe<ApplicationServiceFilterInput>;
  serviceId?: InputMaybe<UuidOperationFilterInput>;
};

export type OrganizationInServiceSortInput = {
  claimPrefix?: InputMaybe<SortEnumType>;
  dateCreated?: InputMaybe<SortEnumType>;
  dateExpire?: InputMaybe<SortEnumType>;
  dateStart?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  org?: InputMaybe<OrganizationSortInput>;
  orgId?: InputMaybe<SortEnumType>;
  service?: InputMaybe<ApplicationServiceSortInput>;
  serviceId?: InputMaybe<SortEnumType>;
};

/** Input model for Organization */
export type OrganizationInputModelInput = {
  /** Gets or sets the claim prefix. */
  claimPrefix: Scalars['String']['input'];
  /** Gets or sets the date expire. */
  dateExpire?: InputMaybe<Scalars['DateTime']['input']>;
  /** Gets or sets the date start. */
  dateStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Gets or sets the orgCode. */
  orgCode: Scalars['String']['input'];
  /** Gets or sets the name of the org. */
  orgName: Scalars['String']['input'];
  /** Gets or sets the type of the org. */
  orgType?: InputMaybe<OrgTypes>;
  /** Gets or sets a value indicating whether to require Multi Factor Authentication. */
  requireMFA: Scalars['Boolean']['input'];
  /** Gets or sets the TPA rule. */
  tpaRule: OrgTpaRule;
  /** Gets or sets the tpa rule filter. */
  tpaRuleFilter: Scalars['String']['input'];
};

export type OrganizationSortInput = {
  claimPrefix?: InputMaybe<SortEnumType>;
  dateCreated?: InputMaybe<SortEnumType>;
  dateExpire?: InputMaybe<SortEnumType>;
  dateStart?: InputMaybe<SortEnumType>;
  dateUpdated?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  orgCode?: InputMaybe<SortEnumType>;
  orgName?: InputMaybe<SortEnumType>;
  orgType?: InputMaybe<SortEnumType>;
  requireMFA?: InputMaybe<SortEnumType>;
  tpaRule?: InputMaybe<SortEnumType>;
  tpaRuleFilter?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type OrganizationsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<OrganizationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Organization>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganizationsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Organization;
};

/** A connection to a list of items. */
export type OrganizationsWhereUserIsStaffConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<OrganizationsWhereUserIsStaffEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Organization>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganizationsWhereUserIsStaffEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Organization;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PayloadOfApplicationService = {
  data?: Maybe<ApplicationService>;
  errors?: Maybe<Array<Error>>;
};

export type PayloadOfClaim = {
  data?: Maybe<Claim>;
  errors?: Maybe<Array<Error>>;
};

export type PayloadOfCompletedSuccess = {
  data?: Maybe<CompletedSuccess>;
  errors?: Maybe<Array<Error>>;
};

export type PayloadOfDeleteSuccess = {
  data?: Maybe<DeleteSuccess>;
  errors?: Maybe<Array<Error>>;
};

export type PayloadOfEditLog = {
  data?: Maybe<EditLog>;
  errors?: Maybe<Array<Error>>;
};

export type PayloadOfExternalProvider = {
  data?: Maybe<ExternalProvider>;
  errors?: Maybe<Array<Error>>;
};

export type PayloadOfOrganization = {
  data?: Maybe<Organization>;
  errors?: Maybe<Array<Error>>;
};

export type PayloadOfOrganizationInOrganization = {
  data?: Maybe<OrganizationInOrganization>;
  errors?: Maybe<Array<Error>>;
};

export type PayloadOfOrganizationInRole = {
  data?: Maybe<OrganizationInRole>;
  errors?: Maybe<Array<Error>>;
};

export type PayloadOfOrganizationInService = {
  data?: Maybe<OrganizationInService>;
  errors?: Maybe<Array<Error>>;
};

export type PayloadOfProviderInOrg = {
  data?: Maybe<ProviderInOrg>;
  errors?: Maybe<Array<Error>>;
};

export type PayloadOfServiceRole = {
  data?: Maybe<ServiceRole>;
  errors?: Maybe<Array<Error>>;
};

export type PayloadOfString = {
  data?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

export type PayloadOfUpdateSuccess = {
  data?: Maybe<UpdateSuccess>;
  errors?: Maybe<Array<Error>>;
};

export type PayloadOfUser = {
  data?: Maybe<User>;
  errors?: Maybe<Array<Error>>;
};

export type PayloadOfUserClaim = {
  data?: Maybe<UserClaim>;
  errors?: Maybe<Array<Error>>;
};

export type PayloadOfUserInOrganization = {
  data?: Maybe<UserInOrganization>;
  errors?: Maybe<Array<Error>>;
};

export type PayloadOfUserOrganizationInOrganizationRole = {
  data?: Maybe<UserOrganizationInOrganizationRole>;
  errors?: Maybe<Array<Error>>;
};

export type ProviderInOrg = {
  id: Scalars['UUID']['output'];
  orgId: Scalars['UUID']['output'];
  provider?: Maybe<ExternalProvider>;
  providerScheme?: Maybe<Scalars['String']['output']>;
};

export type ProviderInOrgFilterInput = {
  and?: InputMaybe<Array<ProviderInOrgFilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<ProviderInOrgFilterInput>>;
  orgId?: InputMaybe<UuidOperationFilterInput>;
  provider?: InputMaybe<ExternalProviderFilterInput>;
  providerScheme?: InputMaybe<StringOperationFilterInput>;
};

export type ProviderInOrgSortInput = {
  id?: InputMaybe<SortEnumType>;
  orgId?: InputMaybe<SortEnumType>;
  provider?: InputMaybe<ExternalProviderSortInput>;
  providerScheme?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProviderInOrgsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<ProviderInOrgsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProviderInOrg>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProviderInOrgsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProviderInOrg;
};

/** The provider in orgs input model. */
export type ProviderInOrgsInputModelInput = {
  /** Gets or Sets the org id. */
  orgId: Scalars['UUID']['input'];
  /** Gets or Sets the provider scheme. */
  providerScheme: Scalars['String']['input'];
};

/** The provider input model. */
export type ProviderInputModelInput = {
  /** Gets or sets the created at. */
  createdAt: Scalars['DateTime']['input'];
  /** Gets or sets the display name. */
  displayName: Scalars['String']['input'];
  /** Gets or sets the scheme. */
  id: Scalars['String']['input'];
  /** Gets or sets the map default outbound claim type. */
  mapDefaultOutboundClaimType: Scalars['Boolean']['input'];
  /** Gets or sets the modified at. */
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Gets or sets the serialized handler type. 'Should be JSON' */
  serializedHandlerType: Scalars['String']['input'];
  /** Gets or sets the serialized options. 'Should be JSON' */
  serializedOptions: Scalars['String']['input'];
  /** Gets or sets the store claims. */
  storeClaims: Scalars['Boolean']['input'];
};

/** A connection to a list of items. */
export type ProvidersConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<ProvidersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ExternalProvider>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProvidersEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ExternalProvider;
};

/** Provides the mutations for the rbs services. */
export type RbsMutation = {
  /**
   * Adds the user to orgv02.
   *
   *
   * **Returns:**
   * A Task.
   */
  addUserToOrgv02: BoolResultModel;
  /**
   * Applies all deprecation rules to filter claims based on the last accessed date.
   *
   *
   * **Returns:**
   * An IQueryable of DeprecationUserData that match the deprecation rule criteria.
   */
  applyAllDeprecationRules: Array<DeprecationUserData>;
  /**
   * Applies the ninety-day rule to filter claims based on the last accessed date.
   *
   *
   * **Returns:**
   * An IQueryable of DeprecationUserData that match the ninety-day rule criteria.
   */
  applyNinetyDayRule: Array<DeprecationUserData>;
  /**
   * Applies the one hundred twenty-day rule to hard delete users from the database.
   *
   *
   * **Returns:**
   * An IQueryable of DeprecationUserData that match the one hundred twenty-day rule criteria.
   */
  applyOneTwentyDayRule: Array<DeprecationUserData>;
  /**
   * Applies the sixty-day rule to filter claims based on the last accessed date.
   *
   *
   * **Returns:**
   * An IQueryable of DeprecationUserData that match the sixty-day rule criteria.
   */
  applySixtyDayRule: Array<DeprecationUserData>;
  /**
   * Applies the thirty-day rule to filter claims based on the last accessed date.
   *
   *
   * **Returns:**
   * An IQueryable of DeprecationUserData that match the thirty-day rule criteria.
   */
  applyThirtyDayRule: Array<DeprecationUserData>;
  /**
   * Changes a user's organization role by expiring the current UserOrganizationInOrganizationRole
   * and creating a new one.
   * Matching of ServiceRole names is now case-insensitive.
   */
  changeUserOrgRole: PayloadOfUserOrganizationInOrganizationRole;
  /**
   * Create a new Organization.
   *
   *
   * **Returns:**
   * The new application service.
   */
  createApplicationService: PayloadOfApplicationService;
  /**
   * Create a new Claim
   *
   *
   * **Returns:**
   * Results
   */
  createClaim: PayloadOfClaim;
  /**
   * Creates the log entry.
   *
   *
   * **Returns:**
   * A Task.
   */
  createLogEntry: PayloadOfEditLog;
  /**
   * Creates the new user.
   *
   *
   * **Returns:**
   * Task<BoolResultModel>
   */
  createNewUser: GuidResultsModel;
  /**
   * Creates the org in role.
   *
   *
   * **Returns:**
   * Task<Payload<OrganizationInRole>>
   */
  createOrgInRole: PayloadOfOrganizationInRole;
  /**
   * Creates the org in service.
   *
   *
   * **Returns:**
   * Task<Payload<OrganizationInService>>
   */
  createOrgInService: PayloadOfOrganizationInService;
  /**
   * Create a new Organization.
   *
   *
   * **Returns:**
   * The new organization.
   */
  createOrganization: PayloadOfOrganization;
  /**
   * Create a new Organization in Organization.
   *
   *
   * **Returns:**
   * The new Organization in organization entity.
   */
  createOrganizationInOrganization: PayloadOfOrganizationInOrganization;
  /**
   * Creates the provider.
   *
   *
   * **Returns:**
   * A Task.
   */
  createProvider: PayloadOfExternalProvider;
  /**
   * Creates the provider in org.
   *
   *
   * **Returns:**
   * A Task.
   */
  createProviderInOrg: PayloadOfProviderInOrg;
  /**
   * Creates the service role.
   *
   *
   * **Returns:**
   * Task<Payload<ServiceRole>>
   */
  createServiceRole: PayloadOfServiceRole;
  /**
   * Creates a new user claim.
   *
   *
   * **Returns:**
   * A payload containing the created user claim.
   */
  createUserClaim: PayloadOfUserClaim;
  /**
   * Create a new UserInOrganization.
   *
   *
   * **Returns:**
   * The new UserInOrg entity.
   */
  createUserInOrganization: PayloadOfUserInOrganization;
  /** Creates the user orgs in org roles. */
  createUserOrgsInOrgRoles: PayloadOfUserOrganizationInOrganizationRole;
  /**
   * Delete an existing Application Service.
   *
   *
   * **Returns:**
   * The delete success payload.
   */
  deleteApplicationService: PayloadOfDeleteSuccess;
  /**
   * Set a ExpireDate to Rbs.Claim
   *
   *
   * **Returns:**
   * Bool
   */
  deleteClaims: PayloadOfDeleteSuccess;
  /**
   * Deletes the org in role.
   *
   *
   * **Returns:**
   * Task<Payload<DeleteSuccess>>
   */
  deleteOrgInRole: PayloadOfDeleteSuccess;
  /**
   * Deletes the org in services.
   *
   *
   * **Returns:**
   * Task<Payload<DeleteSuccess>>
   */
  deleteOrgInServices: PayloadOfDeleteSuccess;
  /**
   * Delete an existing Organization.
   *
   *
   * **Returns:**
   * True if found, false otherwise.
   */
  deleteOrganization: PayloadOfDeleteSuccess;
  /**
   * Delete an existing OrganizationInOrganization entity.
   *
   *
   * **Returns:**
   * True if found, false otherwise.
   */
  deleteOrganizationInOrganization: PayloadOfDeleteSuccess;
  /**
   * Deletes the services roles.
   *
   *
   * **Returns:**
   * Task<Payload<DeleteSuccess>>
   */
  deleteServicesRoles: PayloadOfDeleteSuccess;
  /**
   * Deletes a user claim by ID.
   *
   *
   * **Returns:**
   * A payload indicating the success of the deletion.
   */
  deleteUserClaims: PayloadOfDeleteSuccess;
  /**
   * Deletes user in organization.
   *
   *
   * **Returns:**
   * Task<Payload<DeleteSuccess>>
   */
  deleteUserInOrganization: PayloadOfDeleteSuccess;
  /** Deletes the user orgs in org roles. */
  deleteUserOrgsInOrgRoles: PayloadOfDeleteSuccess;
  /** Deletes a user orgs in org roles by UserInOrgId and ServiceRoleEnum. */
  deleteUserOrgsInOrgRolesByUserInOrgId: PayloadOfDeleteSuccess;
  /**
   * Deletes all sessions for a user.
   *
   *
   * **Returns:**
   * True if sessions were successfully deleted, false otherwise.
   */
  deleteUserSessions: BoolResultModel;
  /**
   * Deletes all sessions for the current user.
   *
   *
   * **Returns:**
   * A JSON string representing the delete result.
   */
  deleteUserSessionsForCurrentUser: Scalars['String']['output'];
  /**
   * Enables two factor email code
   *
   *
   * **Returns:**
   * Claim data
   */
  enableTwoFactorEmailCode: BoolResultModel;
  /**
   * Forces re-onboarding by deleting all user claims for a specific user.
   *
   *
   * **Returns:**
   * A payload indicating the success of the deletion.
   */
  forceReOnBoarding: PayloadOfDeleteSuccess;
  /**
   * Generates Recovery Codes when Two Factor Enabled.
   *
   *
   * **Returns:**
   * The recovery codes.
   */
  generateRecoveryCodes: StringResultModel;
  /**
   * Generates recovery codes for the current user.
   *
   *
   * **Returns:**
   * A JSON string representing the recovery codes result.
   */
  generateRecoveryCodesForCurrentUser: Scalars['String']['output'];
  /**
   * Hards the delete user async. - Some tables cant be cleared until we have a single dbcontext
   *
   *
   * **Returns:**
   * Bool
   */
  hardDeleteUser: PayloadOfDeleteSuccess;
  /** Links user organization in organization role. */
  linkUserOrganizationInOrganizationRole: PayloadOfUserOrganizationInOrganizationRole;
  /** Links a user to an organization role within a specific application service. */
  linkUserToOrganizationInOrganizationRole: PayloadOfUserOrganizationInOrganizationRole;
  /**
   * Delete authenticator info and claims, pretend user never logged in,
   * resend them their welcome email.
   */
  reOnboardUser: BoolResultModel;
  /**
   * Retrieves a recovery code for a user.
   *
   *
   * **Returns:**
   * The recovery code.
   */
  recoveryCode: StringResultModel;
  /** Resets the Auth App and enables Email 2FA */
  resetAuthApp: BoolResultModel;
  /**
   * Starts the reset password process for a user.
   *
   *
   * **Returns:**
   * True if email successfully sent, false otherwise.
   */
  resetPassword: BoolResultModel;
  retireUser: PayloadOfDeleteSuccess;
  /**
   * Sets the last accessed date claim for a user in a specific organization.
   *
   *
   * **Returns:**
   * A payload indicating the success of the operation.
   */
  setAccountLoginDateClaim: PayloadOfCompletedSuccess;
  /**
   * Adds or updates a user claim for account selection. If the claim does not exist, it creates a new one.
   * If the claim exists, it deletes the existing claim and creates a new one with the provided input.
   * Returns a payload containing the ID of the created user claim or errors if the operation fails.
   *
   *
   * **Returns:**
   * A payload containing the ID of the created user claim or errors.
   */
  setAccountSelectorClaim: PayloadOfString;
  /**
   * Sets the deprecation rule for an organization by its ID.
   *
   *
   * **Returns:**
   * A payload indicating the success of the operation.
   */
  setDeprecationRuleByOrgId: PayloadOfCompletedSuccess;
  /**
   * Softs the delete user.
   *
   *
   * **Returns:**
   * A Payload.
   */
  softDeleteUser: PayloadOfUser;
  /**
   * Uns the soft delete user async.
   *
   *
   * **Returns:**
   * A Task.
   */
  unSoftDeleteUser: PayloadOfUser;
  /**
   * Unlock a user's account.
   *
   *
   * **Returns:**
   * True if unlock successful, false otherwise.
   */
  unlockUser: BoolResultModel;
  /**
   * Update an existing Application Service.
   *
   *
   * **Returns:**
   * The updated application service.
   */
  updateApplicationService: PayloadOfApplicationService;
  /**
   * Updates existing Claims entity
   *
   *
   * **Returns:**
   * Claim data
   */
  updateClaims: PayloadOfClaim;
  /**
   * Updates the current user's data with the provided input model.
   *
   *
   * **Returns:**
   * A JSON string representing the update result.
   */
  updateCurrentUserData: Scalars['String']['output'];
  /**
   * Updates the org in role.
   *
   *
   * **Returns:**
   * Task<Payload<OrganizationInRole>>
   */
  updateOrgInRole: PayloadOfOrganizationInRole;
  /**
   * Updates the org in service.
   *
   *
   * **Returns:**
   * Task<Payload<OrganizationInService>>
   */
  updateOrgInService: PayloadOfOrganizationInService;
  /**
   * Update an existing Organization.
   *
   *
   * **Returns:**
   * The updated organization.
   */
  updateOrganization: PayloadOfOrganization;
  /**
   * Updates an existing organization in organization entity.
   *
   *
   * **Returns:**
   * The updated organization in organization entity.
   */
  updateOrganizationInOrganization: PayloadOfOrganizationInOrganization;
  /**
   * Updates the provider.
   *
   *
   * **Returns:**
   * A Task.
   */
  updateProvider: PayloadOfExternalProvider;
  /**
   * Updates the provider.
   *
   *
   * **Returns:**
   * A Task.
   */
  updateProviderInOrg: PayloadOfProviderInOrg;
  /**
   * Updates the service role.
   *
   *
   * **Returns:**
   * Task<Payload<ServiceRole>>
   */
  updateServiceRole: PayloadOfServiceRole;
  /**
   * Updates existing userclaim
   *
   *
   * **Returns:**
   * A payload with user claim data
   */
  updateUserClaim: PayloadOfUserClaim;
  /**
   * Updates the user data.
   *
   *
   * **Returns:**
   * A Task.
   */
  updateUserData: PayloadOfUpdateSuccess;
  /**
   * Updates an existing UserInOrg entity.
   *
   *
   * **Returns:**
   * The updated UserInOrg entity.
   */
  updateUserInOrganization: PayloadOfUserInOrganization;
  /** Send a verification code to user. */
  verificationCode: StringResultModel;
  /** Verifies code from Auth App */
  verifyAuthAppCode: BoolResultModel;
  /**
   * Verifies the Auth App code for the current user.
   *
   *
   * **Returns:**
   * A JSON string representing the verification result.
   */
  verifyAuthAppCodeForCurrentUser: Scalars['String']['output'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationAddUserToOrgv02Args = {
  claimPrefix: Scalars['String']['input'];
  expirationDate: Scalars['String']['input'];
  isStaff?: Scalars['Boolean']['input'];
  orgId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationChangeUserOrgRoleArgs = {
  currentUserInOrgID: Scalars['UUID']['input'];
  newServiceRoleEnum: ServiceRoleEnum;
  oldserviceRoleEnum: ServiceRoleEnum;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationCreateApplicationServiceArgs = {
  input: ApplicationServicesInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationCreateClaimArgs = {
  input: ClaimsInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationCreateLogEntryArgs = {
  input: EditLogInPutModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationCreateNewUserArgs = {
  employerName: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  generatepassword?: Scalars['Boolean']['input'];
  lastname: Scalars['String']['input'];
  phonenumber: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationCreateOrgInRoleArgs = {
  input: OrgInRoleInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationCreateOrgInServiceArgs = {
  input: OrgInServicesInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationCreateOrganizationArgs = {
  input: OrganizationInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationCreateOrganizationInOrganizationArgs = {
  input: OrganizationInOrganizationInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationCreateProviderArgs = {
  input: ProviderInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationCreateProviderInOrgArgs = {
  input: ProviderInOrgsInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationCreateServiceRoleArgs = {
  input: ServicesRolesInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationCreateUserClaimArgs = {
  input: UserClaimsInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationCreateUserInOrganizationArgs = {
  input: UserInOrganizationInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationCreateUserOrgsInOrgRolesArgs = {
  input: UserOrgsInOrgRolesInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationDeleteApplicationServiceArgs = {
  id: Scalars['UUID']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationDeleteClaimsArgs = {
  id: Scalars['UUID']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationDeleteOrgInRoleArgs = {
  id: Scalars['UUID']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationDeleteOrgInServicesArgs = {
  id: Scalars['UUID']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationDeleteOrganizationArgs = {
  id: Scalars['UUID']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationDeleteOrganizationInOrganizationArgs = {
  id: Scalars['UUID']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationDeleteServicesRolesArgs = {
  id: Scalars['UUID']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationDeleteUserClaimsArgs = {
  id: Scalars['UUID']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationDeleteUserInOrganizationArgs = {
  organizationId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationDeleteUserOrgsInOrgRolesArgs = {
  id: Scalars['UUID']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationDeleteUserOrgsInOrgRolesByUserInOrgIdArgs = {
  serviceRoleEnum: ServiceRoleEnum;
  userInOrgID: Scalars['UUID']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationDeleteUserSessionsArgs = {
  userId: Scalars['UUID']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationEnableTwoFactorEmailCodeArgs = {
  userId: Scalars['UUID']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationForceReOnBoardingArgs = {
  userid: Scalars['UUID']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationGenerateRecoveryCodesArgs = {
  userId: Scalars['UUID']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationHardDeleteUserArgs = {
  username: Scalars['String']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationLinkUserOrganizationInOrganizationRoleArgs = {
  appServiceId: Scalars['UUID']['input'];
  claimPrefix: Scalars['String']['input'];
  orgId: Scalars['UUID']['input'];
  serviceRoleId: Scalars['UUID']['input'];
  userInOrgId: Scalars['UUID']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationLinkUserToOrganizationInOrganizationRoleArgs = {
  appServicesEnum: ApplicationServicesEnum;
  claimPrefix: Scalars['String']['input'];
  orgId: Scalars['UUID']['input'];
  serviceRoleEnum: ServiceRoleEnum;
  userInOrgId: Scalars['UUID']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationReOnboardUserArgs = {
  username: Scalars['String']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationRecoveryCodeArgs = {
  userId: Scalars['UUID']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationResetAuthAppArgs = {
  username: Scalars['String']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationResetPasswordArgs = {
  username: Scalars['String']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationRetireUserArgs = {
  username: Scalars['String']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationSetAccountLoginDateClaimArgs = {
  orgid: Scalars['UUID']['input'];
  userid: Scalars['UUID']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationSetAccountSelectorClaimArgs = {
  userId: Scalars['UUID']['input'];
  userInOrgId: Scalars['UUID']['input'];
  userOrgInOrgRolesId: Scalars['UUID']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationSetDeprecationRuleByOrgIdArgs = {
  input: DeprecationRuleInputModelInput;
  orgid: Scalars['UUID']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationSoftDeleteUserArgs = {
  username: Scalars['String']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationUnSoftDeleteUserArgs = {
  username: Scalars['String']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationUnlockUserArgs = {
  username: Scalars['String']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationUpdateApplicationServiceArgs = {
  id: Scalars['UUID']['input'];
  input: ApplicationServicesInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationUpdateClaimsArgs = {
  id: Scalars['UUID']['input'];
  input: ClaimsInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationUpdateCurrentUserDataArgs = {
  input: UserUpdateInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationUpdateOrgInRoleArgs = {
  id: Scalars['UUID']['input'];
  input: OrgInRoleInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationUpdateOrgInServiceArgs = {
  id: Scalars['UUID']['input'];
  input: OrgInServicesInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationUpdateOrganizationArgs = {
  id: Scalars['UUID']['input'];
  input: OrganizationInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationUpdateOrganizationInOrganizationArgs = {
  id: Scalars['UUID']['input'];
  input: OrganizationInOrganizationInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationUpdateProviderArgs = {
  input: ProviderInputModelInput;
  scheme: Scalars['String']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationUpdateProviderInOrgArgs = {
  id: Scalars['UUID']['input'];
  input: ProviderInOrgsInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationUpdateServiceRoleArgs = {
  id: Scalars['UUID']['input'];
  input: ServicesRolesInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationUpdateUserClaimArgs = {
  input: UserClaimsInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationUpdateUserDataArgs = {
  input: UserUpdateInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationUpdateUserInOrganizationArgs = {
  id: Scalars['UUID']['input'];
  input: UserInOrganizationInputModelInput;
};


/** Provides the mutations for the rbs services. */
export type RbsMutationVerificationCodeArgs = {
  username: Scalars['String']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationVerifyAuthAppCodeArgs = {
  username: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};


/** Provides the mutations for the rbs services. */
export type RbsMutationVerifyAuthAppCodeForCurrentUserArgs = {
  verificationCode: Scalars['String']['input'];
};

/** Provides the queries for the rbs services. */
export type RbsQuery = {
  /**
   * With the requested Application Service Id, gets the Organization, User, and Service Role by the current user.
   *
   *
   * **Returns:**
   * IQueryable<UserOrganizationInOrganizationRole>
   */
  applicationAccounts?: Maybe<ApplicationAccountsConnection>;
  /**
   * Gets the application service by enum.
   *
   *
   * **Returns:**
   * An IQueryable of ApplicationService.
   */
  applicationServiceByEnum?: Maybe<ApplicationServiceByEnumConnection>;
  /** Get a ApplicationService for the given Id. */
  applicationServiceById?: Maybe<ApplicationService>;
  /** Get the collection of ApplicationService. */
  applicationServices?: Maybe<ApplicationServicesConnection>;
  /** Get a list of ApplicationServices for the given list of ids. */
  applicationServicesByIds: Array<ApplicationService>;
  /**
   * Gets the application services contains name.
   *
   *
   * **Returns:**
   * An IQueryable.
   */
  applicationServicesContainsName?: Maybe<ApplicationServicesContainsNameConnection>;
  /** Get QR code and secret to setup the Auth App */
  authAppCode: StringResultModel;
  /**
   * Retrieves the current user's Auth App code using the UserManagerQuery logic.
   *
   *
   * **Returns:**
   * A JSON string representing the current user's Auth App code result.
   */
  authAppCodeForCurrentUser: Scalars['String']['output'];
  /**
   * Get the collection of Claims.
   *
   *
   * **Returns:**
   * A collection of Claims objects.
   */
  claims?: Maybe<ClaimsConnection>;
  /**
   * Get a Claim object by ParentId (ANY RBS table ID, excluding Claims).
   *
   *
   * **Returns:**
   * The found Claims reference or nothing if it does not exist.
   */
  claimsByParentId?: Maybe<ClaimsByParentIdConnection>;
  /**
   * Retrieves the current user's details based on their claims.
   *
   *
   * **Returns:**
   * A JSON string representing the current user's details.
   */
  currentUser: Scalars['String']['output'];
  /**
   * Retrieves the current user's roles for a specific organization membership.
   *
   *
   * **Returns:**
   * A JSON string representing the current user's roles in the specified organization.
   */
  currentUsersRoles: Scalars['String']['output'];
  /**
   * Get the collection of Deprecation Claims for the given user.
   *
   *
   * **Returns:**
   * A collection of Claims objects.
   */
  deprecationClaimsByUserId?: Maybe<DeprecationClaimsByUserIdConnection>;
  /**
   * Get the claims for the deprecation rule by user id.
   *
   *
   * **Returns:**
   * A collection of Claims objects.
   */
  deprecationRulesByCurrentUser: Scalars['String']['output'];
  /**
   * Gets the edit logs by user id.
   *
   *
   * **Returns:**
   * An IQueryable.
   */
  editLogs?: Maybe<EditLogsConnection>;
  /**
   * Get the collection of Feature Claims for the given user in organization.
   *
   *
   * **Returns:**
   * A collection of Claims objects associated with the user's organization services.
   */
  featureClaims: Array<Claim>;
  /**
   * Gets the filtered users for support.
   *
   *
   * **Returns:**
   * A Task.
   */
  filteredUsersForSupport: StringResultModel;
  /**
   * Get all soft deleted users.
   *
   *
   * **Returns:**
   * An IQueryable.
   */
  findAllSoftDeletedUsers?: Maybe<FindAllSoftDeletedUsersConnection>;
  /**
   * Get a soft deleted user by original username.
   *
   *
   * **Returns:**
   * An instance of StringListResultsModel.
   */
  findSoftDeletedUserByOriginalUserName: StringListResultsModel;
  /**
   * Returns a new Guid.
   *
   *
   * **Returns:**
   * A new Guid.
   */
  guidValue: Scalars['UUID']['output'];
  /** Get a Home Page Link for the given Id. */
  homePageLinkById?: Maybe<HomePageLink>;
  /** Get the collection of Home Page Links. */
  homePageLinks?: Maybe<HomePageLinksConnection>;
  /** Get a list of Home Page Links for the given list of ids. */
  homePageLinksByIds: Array<HomePageLink>;
  /**
   * Gets the identity claims v02.
   *
   *
   * **Returns:**
   * A Task.
   */
  identityClaimsV02: Array<KeyValuePairOfStringAndString>;
  /** Determines if two factor email code is enabled */
  isTwoFactorEmailCodeEnabled: BoolResultModel;
  /**
   * Gets the org in role all.
   *
   *
   * **Returns:**
   * IQueryable<OrgInRole>
   */
  orgInRole?: Maybe<OrgInRoleConnection>;
  /**
   * Gets the org in role by id.
   *
   *
   * **Returns:**
   * IQueryable<OrgInRole>
   */
  orgInRoleById?: Maybe<OrganizationInRole>;
  /**
   * Gets the org in services by id.
   *
   *
   * **Returns:**
   * IQueryable<OrgInService>
   */
  orgInServiceById?: Maybe<OrganizationInService>;
  /**
   * Gets the org in services all.
   *
   *
   * **Returns:**
   * IQueryable<OrgInService>
   */
  orgInServices?: Maybe<OrgInServicesConnection>;
  /** Get an organization for the given id. */
  organizationById?: Maybe<Organization>;
  /**
   * Get organization by org code.
   *
   *
   * **Returns:**
   * IQueryable<Organization>
   */
  organizationByOrgCode?: Maybe<Organization>;
  /** Get an org by name. MKR, you really don't need this. */
  organizationByOrgName?: Maybe<Organization>;
  /** Get org by name substring. See above. Filtering exists. */
  organizationContainsOrgName?: Maybe<OrganizationContainsOrgNameConnection>;
  /**
   * Get the collection of Organizations in Organizations.
   *
   *
   * **Returns:**
   * The collection of organizations in organizations.
   */
  organizationInOrganization?: Maybe<OrganizationInOrganizationConnection>;
  /** Get an Organization in Organization by id. */
  organizationInOrganizationById?: Maybe<OrganizationInOrganization>;
  /** Get a list of organization in organizations by a list of ids. */
  organizationInOrganizationByIds: Array<OrganizationInOrganization>;
  /**
   * Get the collection of Organizations.
   *
   *
   * **Returns:**
   * The collection of Organizations.
   */
  organizations?: Maybe<OrganizationsConnection>;
  /** Get a list of organizations for the given list of ids. */
  organizationsByIds: Array<Organization>;
  /**
   * Gets the organizations where user is staff.
   *
   *
   * **Returns:**
   * An IQueryable.
   */
  organizationsWhereUserIsStaff?: Maybe<OrganizationsWhereUserIsStaffConnection>;
  /**
   * Gets the all provider in orgs.
   *
   *
   * **Returns:**
   * IQueryable<ProviderInOrgView>
   */
  providerInOrgs?: Maybe<ProviderInOrgsConnection>;
  /**
   * Gets the all providers.
   *
   *
   * **Returns:**
   * An IQueryable.
   */
  providers?: Maybe<ProvidersConnection>;
  /**
   * Gets the all providers by org id.
   *
   *
   * **Returns:**
   * IQueryable<ProviderInOrgView>
   */
  providersByOrgId: Array<ProviderInOrg>;
  /**
   * Gets the providers by scheme.
   *
   *
   * **Returns:**
   * An IQueryable.
   */
  providersByScheme?: Maybe<ExternalProvider>;
  /**
   * Gets the all providers by provider scheme.
   *
   *
   * **Returns:**
   * IQueryable<ProviderInOrgView>
   */
  providersInOrgByScheme: Array<ProviderInOrg>;
  /**
   * Gets the service roles by id.
   *
   *
   * **Returns:**
   * IQueryable<ServiceRole>
   */
  serviceRoleById?: Maybe<ServiceRole>;
  serviceRoleContainsByEnum?: Maybe<ServiceRoleContainsByEnumConnection>;
  /**
   * Gets the service roles contains name
   *
   *
   * **Returns:**
   * IQueryable<ServiceRole>
   */
  serviceRoleContainsName?: Maybe<ServiceRoleContainsNameConnection>;
  /**
   * Gets the service roles all.
   *
   *
   * **Returns:**
   * IQueryable<ServiceRole>
   */
  serviceRoles?: Maybe<ServiceRolesConnection>;
  /**
   * Returns agency/contractor relationship rows for the user that owns the supplied UserInOrganization Id.
   * If userInOrgId is null or whitespace an empty set is returned (logged). If provided but invalid format or
   * not found, an empty set is also returned (logged). Each row represents a pairing of one agency membership
   * (IsStaff = false) and one contractor membership (IsStaff = true) for the same user; missing sides are null.
   *
   *
   * **Returns:**
   * IQueryable of AgencyContractorUserLink.
   */
  userAgencyContractorLinks: Array<AgencyContractorUserLink>;
  /**
   * Get a user by id.
   *
   *
   * **Returns:**
   * The found User or nothing if it does not exist.
   */
  userById?: Maybe<User>;
  /**
   * Get the collection of User Claims.
   *
   *
   * **Returns:**
   * A collection of Claims objects.
   */
  userClaims?: Maybe<UserClaimsConnection>;
  /**
   * Get a Claim object by ParentId (ANY RBS table ID, excluding Claims).
   *
   *
   * **Returns:**
   * The found Claims reference or nothing if it does not exist.
   */
  userClaimsByUserId?: Maybe<UserClaimsByUserIdConnection>;
  /**
   * Retrieves the claims for the current user based on their claims and an optional claim type filter.
   *
   *
   * **Returns:**
   * A JSON string representing the filtered claims for the current user.
   */
  userClaimsForCurrentUser: Scalars['String']['output'];
  /**
   * Gets the user login all.
   *
   *
   * **Returns:**
   * IQueryable<UserLogin>
   */
  userExternalLoginAll?: Maybe<UserExternalLoginAllConnection>;
  /**
   * Gets the user logins by user id.
   *
   *
   * **Returns:**
   * IQueryable<UserLogin>
   */
  userExternalLoginsByUserId: Array<UserLogin>;
  /**
   * Retrieves a single UserInOrganization by its unique identifier.
   *
   *
   * **Returns:**
   * IQueryable yielding at most one UserInOrganization.
   */
  userInOrganizationById?: Maybe<UserInOrganization>;
  /**
   * Retrieves a collection of UserInOrganization records whose Ids match the provided set.
   *
   *
   * **Returns:**
   * IQueryable of matching UserInOrganization entities.
   */
  userInOrganizationsByIds: Array<UserInOrganization>;
  /**
   * Retrieves all UserInOrganization records for a specific user.
   *
   *
   * **Returns:**
   * IQueryable of UserInOrganization filtered by user Id.
   */
  userInOrganizationsByUserId: Array<UserInOrganization>;
  /**
   * Get the collection of User login history.
   *
   *
   * **Returns:**
   * The collection of User login history.
   */
  userLoginHistory?: Maybe<UserLoginHistoryConnection>;
  userLoginHistoryByUserId?: Maybe<UserLoginHistoryByUserIdConnection>;
  /**
   * Retrieves the login history for the current user based on the provided filters.
   *
   *
   * **Returns:**
   * A JSON string representing the filtered login history for the current user.
   */
  userLoginHistoryForCurrentUser: Scalars['String']['output'];
  /**
   * Gets the user orgs in org roles.
   *
   *
   * **Returns:**
   * IQueryable<UserOrganizationInOrganizationRole>
   */
  userOrgsInOrgRoles?: Maybe<UserOrgsInOrgRolesConnection>;
  /**
   * Gets the service role by id.
   *
   *
   * **Returns:**
   * An IQueryable<UserOrganizationInOrganizationRole>? .
   */
  userOrgsInOrgRolesById?: Maybe<UserOrganizationInOrganizationRole>;
  /**
   * Gets the user orgs in org roles by ids.
   *
   *
   * **Returns:**
   * IQueryable<UserOrganizationInOrganizationRole>
   */
  userOrgsInOrgRolesByIds: Array<UserOrganizationInOrganizationRole>;
  /**
   * Retrieves user sessions.
   *
   *
   * **Returns:**
   * The list of user sessions.
   */
  userSessions: UserSessionsListResultsModel;
  /**
   * Retrieves the current user's active sessions using the UserManagerQuery.
   *
   *
   * **Returns:**
   * A JSON string representing the current user's sessions.
   */
  userSessionsForCurrentUser: Scalars['String']['output'];
  /**
   * Get the collection of Users.
   *
   *
   * **Returns:**
   * The collection of Users.
   */
  users?: Maybe<UsersConnection>;
  /**
   * Get the collection of Users by search criteria.
   *
   *
   * **Returns:**
   * The collection of Users.
   */
  usersBy?: Maybe<UsersByConnection>;
  /**
   * Get a collection of Users by ids.
   *
   *
   * **Returns:**
   * The collection of found Users.
   */
  usersByIds: Array<User>;
  /**
   * Retrieves a paged, filterable, sortable list of all UserInOrganization records.
   *
   *
   * **Returns:**
   * IQueryable of UserInOrganization.
   */
  usersInOrganizations?: Maybe<UsersInOrganizationsConnection>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryApplicationAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  appId: Scalars['UUID']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserOrganizationInOrganizationRoleSortInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  userOrgInOrgRoleId?: InputMaybe<Scalars['String']['input']>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryApplicationServiceByEnumArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ApplicationServiceSortInput>>;
  servicesEnum: ApplicationServicesEnum;
  where?: InputMaybe<ApplicationServiceFilterInput>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryApplicationServiceByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryApplicationServicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ApplicationServiceSortInput>>;
  where?: InputMaybe<ApplicationServiceFilterInput>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryApplicationServicesByIdsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryApplicationServicesContainsNameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Array<ApplicationServiceSortInput>>;
  where?: InputMaybe<ApplicationServiceFilterInput>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryAuthAppCodeArgs = {
  username: Scalars['String']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryClaimsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ClaimSortInput>>;
  where?: InputMaybe<ClaimFilterInput>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryClaimsByParentIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryCurrentUsersRolesArgs = {
  userinorgid: Scalars['UUID']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryDeprecationClaimsByUserIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ClaimSortInput>>;
  userId: Scalars['UUID']['input'];
  where?: InputMaybe<ClaimFilterInput>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryEditLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EditResultsModelSortInput>>;
  where?: InputMaybe<EditResultsModelFilterInput>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryFeatureClaimsArgs = {
  userinorgid: Scalars['UUID']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryFilteredUsersForSupportArgs = {
  histLen?: Scalars['String']['input'];
  orderBy?: Scalars['String']['input'];
  searchString: Scalars['String']['input'];
  skip?: Scalars['String']['input'];
  take?: Scalars['String']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryFindAllSoftDeletedUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserSortInput>>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryFindSoftDeletedUserByOriginalUserNameArgs = {
  originalUsername: Scalars['String']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryHomePageLinkByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryHomePageLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<HomePageLinkSortInput>>;
  where?: InputMaybe<HomePageLinkFilterInput>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryHomePageLinksByIdsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryIsTwoFactorEmailCodeEnabledArgs = {
  userId: Scalars['UUID']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryOrgInRoleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrganizationInRoleSortInput>>;
  where?: InputMaybe<OrganizationInRoleFilterInput>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryOrgInRoleByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryOrgInServiceByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryOrgInServicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrganizationInServiceSortInput>>;
  where?: InputMaybe<OrganizationInServiceFilterInput>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryOrganizationByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryOrganizationByOrgCodeArgs = {
  orgCode: Scalars['String']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryOrganizationByOrgNameArgs = {
  orgName: Scalars['String']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryOrganizationContainsOrgNameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrganizationSortInput>>;
  orgName: Scalars['String']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryOrganizationInOrganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrganizationInOrganizationSortInput>>;
  where?: InputMaybe<OrganizationInOrganizationFilterInput>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryOrganizationInOrganizationByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryOrganizationInOrganizationByIdsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrganizationSortInput>>;
  where?: InputMaybe<OrganizationFilterInput>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryOrganizationsByIdsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryOrganizationsWhereUserIsStaffArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrganizationSortInput>>;
  selectedOrgName: Scalars['String']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryProviderInOrgsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProviderInOrgSortInput>>;
  where?: InputMaybe<ProviderInOrgFilterInput>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryProvidersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ExternalProviderSortInput>>;
  where?: InputMaybe<ExternalProviderFilterInput>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryProvidersByOrgIdArgs = {
  orgid: Scalars['UUID']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryProvidersBySchemeArgs = {
  providerScheme: Scalars['String']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryProvidersInOrgBySchemeArgs = {
  providerScheme: Scalars['String']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryServiceRoleByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryServiceRoleContainsByEnumArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ServiceRoleSortInput>>;
  serviceRoleEnum: ServiceRoleEnum;
  where?: InputMaybe<ServiceRoleFilterInput>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryServiceRoleContainsNameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Array<ServiceRoleSortInput>>;
  where?: InputMaybe<ServiceRoleFilterInput>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryServiceRolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ServiceRoleSortInput>>;
  where?: InputMaybe<ServiceRoleFilterInput>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryUserAgencyContractorLinksArgs = {
  userInOrgId?: InputMaybe<Scalars['UUID']['input']>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryUserByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryUserClaimsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserClaimSortInput>>;
  where?: InputMaybe<UserClaimFilterInput>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryUserClaimsByUserIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryUserClaimsForCurrentUserArgs = {
  claimType?: InputMaybe<Scalars['String']['input']>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryUserExternalLoginAllArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserLoginSortInput>>;
  where?: InputMaybe<UserLoginFilterInput>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryUserExternalLoginsByUserIdArgs = {
  userId: Scalars['UUID']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryUserInOrganizationByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryUserInOrganizationsByIdsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryUserInOrganizationsByUserIdArgs = {
  userId: Scalars['UUID']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryUserLoginHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserLoginHistorySortInput>>;
  where?: InputMaybe<UserLoginHistoryFilterInput>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryUserLoginHistoryByUserIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserLoginHistorySortInput>>;
  userId: Scalars['UUID']['input'];
  where?: InputMaybe<UserLoginHistoryFilterInput>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryUserLoginHistoryForCurrentUserArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: SortDirection;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryUserOrgsInOrgRolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserOrganizationInOrganizationRoleSortInput>>;
  where?: InputMaybe<UserOrganizationInOrganizationRoleFilterInput>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryUserOrgsInOrgRolesByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryUserOrgsInOrgRolesByIdsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryUserSessionsArgs = {
  pageNumber?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  userId: Scalars['UUID']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryUserSessionsForCurrentUserArgs = {
  pageNumber?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserSortInput>>;
  where?: InputMaybe<UserFilterInput>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryUsersByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  match?: Scalars['Boolean']['input'];
  order?: InputMaybe<Array<UserSortInput>>;
  searchCriteria: Scalars['String']['input'];
  searchField: Scalars['String']['input'];
};


/** Provides the queries for the rbs services. */
export type RbsQueryUsersByIdsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


/** Provides the queries for the rbs services. */
export type RbsQueryUsersInOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserInOrganizationSortInput>>;
  where?: InputMaybe<UserInOrganizationFilterInput>;
};

export type Role = {
  clone?: Maybe<Role>;
  concurrencyStamp?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  normalizedName?: Maybe<Scalars['String']['output']>;
  roleClaims?: Maybe<Array<Maybe<RoleClaim>>>;
};

export type RoleClaim = {
  claimType: Scalars['String']['output'];
  claimValue?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  role?: Maybe<Role>;
  roleId: Scalars['UUID']['output'];
};

export type ServiceRole = {
  applicationServiceId: Scalars['UUID']['output'];
  applicationSvs?: Maybe<ApplicationService>;
  claimPrefix?: Maybe<Scalars['String']['output']>;
  copiedFromTemplate?: Maybe<ServiceRole>;
  copiedFromTemplateId: Scalars['UUID']['output'];
  dateCreated: Scalars['DateTime']['output'];
  dateExpire?: Maybe<Scalars['DateTime']['output']>;
  dateStart?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isTemplate: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  orgRoles?: Maybe<Array<Maybe<OrganizationInRole>>>;
  templateInstances?: Maybe<Array<Maybe<ServiceRole>>>;
};

/** A connection to a list of items. */
export type ServiceRoleContainsByEnumConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<ServiceRoleContainsByEnumEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ServiceRole>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ServiceRoleContainsByEnumEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ServiceRole;
};

/** A connection to a list of items. */
export type ServiceRoleContainsNameConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<ServiceRoleContainsNameEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ServiceRole>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ServiceRoleContainsNameEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ServiceRole;
};

/** Enum representing user roles. */
export enum ServiceRoleEnum {
  /** Active Insights Access Only */
  ActiveInsightsAccess = 'ACTIVE_INSIGHTS_ACCESS',
  /** Full Admin */
  Admin = 'ADMIN',
  /** Business Manager */
  BusinessManager = 'BUSINESS_MANAGER',
  /** Limited Contractor */
  Contractor = 'CONTRACTOR',
  /** Daily Reporter Manager */
  DailyLogAdmin = 'DAILY_LOG_ADMIN',
  /** Foreman */
  DailyLogUser = 'DAILY_LOG_USER',
  /** Demographic Coordinator */
  DemographicCoordinator = 'DEMOGRAPHIC_COORDINATOR',
  /** DPI Support (INTERNAL ONLY) */
  DpiSupport = 'DPI_SUPPORT',
  /** FeatureMgmt for User Portal */
  FeatureMgmt = 'FEATURE_MGMT',
  /** Field Compliance Monitor */
  FieldComplianceMonitor = 'FIELD_COMPLIANCE_MONITOR',
  /** Full Contractor */
  FullContractor = 'FULL_CONTRACTOR',
  /** IT Security Manager used for User Portal */
  ItSecurityManager = 'IT_SECURITY_MANAGER',
  /** IT Security Tester used for User Portal */
  ItSecurityTester = 'IT_SECURITY_TESTER',
  /** Job Coordinator */
  JobCoordinator = 'JOB_COORDINATOR',
  /** FeatureMgmt for User Portal */
  Lcpdemo = 'LCPDEMO',
  /** Limited Admin */
  LimitedAdmin = 'LIMITED_ADMIN',
  /** Limited Job Coordinator */
  LimitedJobCoordinator = 'LIMITED_JOB_COORDINATOR',
  /** Limited Read Only */
  LimitedReadOnly = 'LIMITED_READ_ONLY',
  /** Manager (CERTIFIED ONLY) */
  Manager = 'MANAGER',
  /** Payroll Admin (CERTIFIED ONLY) */
  PayrollAdmin = 'PAYROLL_ADMIN',
  /** Project Manager */
  PmAdmin = 'PM_ADMIN',
  /** Prime Approver */
  PrimeApprover = 'PRIME_APPROVER',
  /** Read-Only User */
  ReadOnly = 'READ_ONLY',
  /** Superintendent */
  Superintendent = 'SUPERINTENDENT',
  /** Support */
  Support = 'SUPPORT',
  /** Support Admin */
  SupportAdmin = 'SUPPORT_ADMIN',
  /** SupportStaff used for User Portal */
  SupportStaff = 'SUPPORT_STAFF',
  /** SupportStaffManager used for User Portal */
  SupportStaffManager = 'SUPPORT_STAFF_MANAGER',
  /** Wage Data Admin (INTERNAL ONLY) */
  WageDataAdmin = 'WAGE_DATA_ADMIN'
}

export type ServiceRoleFilterInput = {
  and?: InputMaybe<Array<ServiceRoleFilterInput>>;
  applicationServiceId?: InputMaybe<UuidOperationFilterInput>;
  applicationSvs?: InputMaybe<ApplicationServiceFilterInput>;
  claimPrefix?: InputMaybe<StringOperationFilterInput>;
  copiedFromTemplate?: InputMaybe<ServiceRoleFilterInput>;
  copiedFromTemplateId?: InputMaybe<UuidOperationFilterInput>;
  dateCreated?: InputMaybe<DateTimeOperationFilterInput>;
  dateExpire?: InputMaybe<DateTimeOperationFilterInput>;
  dateStart?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isTemplate?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ServiceRoleFilterInput>>;
  orgRoles?: InputMaybe<ListFilterInputTypeOfOrganizationInRoleFilterInput>;
  templateInstances?: InputMaybe<ListFilterInputTypeOfServiceRoleFilterInput>;
};

export type ServiceRoleSortInput = {
  applicationServiceId?: InputMaybe<SortEnumType>;
  applicationSvs?: InputMaybe<ApplicationServiceSortInput>;
  claimPrefix?: InputMaybe<SortEnumType>;
  copiedFromTemplate?: InputMaybe<ServiceRoleSortInput>;
  copiedFromTemplateId?: InputMaybe<SortEnumType>;
  dateCreated?: InputMaybe<SortEnumType>;
  dateExpire?: InputMaybe<SortEnumType>;
  dateStart?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isTemplate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ServiceRolesConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<ServiceRolesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ServiceRole>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ServiceRolesEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ServiceRole;
};

/** Input for Services Roles model */
export type ServicesRolesInputModelInput = {
  /** Gets or Sets the application service id. */
  applicationServiceId: Scalars['UUID']['input'];
  /** Gets or sets the claim prefix */
  claimPrefix: Scalars['String']['input'];
  /** Gets or Sets the copied from template id. */
  copiedFromTemplateId: Scalars['UUID']['input'];
  /** Gets or Sets the date expire. */
  dateExpire?: InputMaybe<Scalars['DateTime']['input']>;
  /** Gets or Sets the date start. */
  dateStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Gets or Sets a value indicating whether is template. */
  isTemplate: Scalars['Boolean']['input'];
  /** Gets or Sets the name. */
  name: Scalars['String']['input'];
};

/** The direction to sort results: ASC or DESC. */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StringListResultsModel = {
  data?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['UUID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  meta: Array<KeyValuePairOfStringAndObject>;
  status: Scalars['Int']['output'];
  unhandledException?: Maybe<Scalars['String']['output']>;
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringResultModel = {
  data?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  meta: Array<KeyValuePairOfStringAndObject>;
  status: Scalars['Int']['output'];
  unhandledException?: Maybe<Scalars['String']['output']>;
};

export type UpdateSuccess = {
  updated: Scalars['Boolean']['output'];
};

export type User = {
  accessFailedCount: Scalars['Int']['output'];
  dateUpdated: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emailConfirmed: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isPasswordExpired: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lockoutEnabled: Scalars['Boolean']['output'];
  lockoutEnd?: Maybe<Scalars['DateTime']['output']>;
  normalizedEmail?: Maybe<Scalars['String']['output']>;
  normalizedUserName?: Maybe<Scalars['String']['output']>;
  phoneExtension?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberConfirmed: Scalars['Boolean']['output'];
  prefix?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  twoFactorEnabled: Scalars['Boolean']['output'];
  userClaims?: Maybe<Array<Maybe<UserClaim>>>;
  userName?: Maybe<Scalars['String']['output']>;
  userRoles?: Maybe<Array<Maybe<UserRole>>>;
  userTokens?: Maybe<Array<Maybe<UserToken>>>;
  usersInOrg?: Maybe<Array<Maybe<UserInOrganization>>>;
};

export type UserClaim = {
  claimType?: Maybe<Scalars['String']['output']>;
  claimValue?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  issuer?: Maybe<Scalars['String']['output']>;
  originalType?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

export type UserClaimFilterInput = {
  and?: InputMaybe<Array<UserClaimFilterInput>>;
  claimType?: InputMaybe<StringOperationFilterInput>;
  claimValue?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  issuer?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserClaimFilterInput>>;
  originalType?: InputMaybe<StringOperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<UuidOperationFilterInput>;
};

export type UserClaimSortInput = {
  claimType?: InputMaybe<SortEnumType>;
  claimValue?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  issuer?: InputMaybe<SortEnumType>;
  originalType?: InputMaybe<SortEnumType>;
  user?: InputMaybe<UserSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type UserClaimsByUserIdConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<UserClaimsByUserIdEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserClaim>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserClaimsByUserIdEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserClaim;
};

/** A connection to a list of items. */
export type UserClaimsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<UserClaimsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserClaim>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserClaimsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserClaim;
};

/** Input for Claims model */
export type UserClaimsInputModelInput = {
  /** Gets the key. */
  claimType: Scalars['String']['input'];
  /** Gets the value. */
  claimValue?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['UUID']['input'];
};

/** A connection to a list of items. */
export type UserExternalLoginAllConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<UserExternalLoginAllEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserLogin>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserExternalLoginAllEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserLogin;
};

export type UserFilterInput = {
  accessFailedCount?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<UserFilterInput>>;
  concurrencyStamp?: InputMaybe<StringOperationFilterInput>;
  dateUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  emailConfirmed?: InputMaybe<BooleanOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  howWasThisRecordCreated?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isPasswordExpired?: InputMaybe<BooleanOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  lockoutEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lockoutEnd?: InputMaybe<DateTimeOperationFilterInput>;
  normalizedEmail?: InputMaybe<StringOperationFilterInput>;
  normalizedUserName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserFilterInput>>;
  password?: InputMaybe<StringOperationFilterInput>;
  phoneExtension?: InputMaybe<StringOperationFilterInput>;
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  phoneNumberConfirmed?: InputMaybe<BooleanOperationFilterInput>;
  prefix?: InputMaybe<StringOperationFilterInput>;
  primaryIdentifierNumber?: InputMaybe<StringOperationFilterInput>;
  securityStamp?: InputMaybe<StringOperationFilterInput>;
  selectedRecoveryAvatar?: InputMaybe<StringOperationFilterInput>;
  suffix?: InputMaybe<StringOperationFilterInput>;
  twoFactorEnabled?: InputMaybe<BooleanOperationFilterInput>;
  userName?: InputMaybe<StringOperationFilterInput>;
  usersInOrg?: InputMaybe<ListFilterInputTypeOfUserInOrganizationFilterInput>;
};

export type UserInOrganization = {
  claimPrefix?: Maybe<Scalars['String']['output']>;
  dateCreated: Scalars['DateTime']['output'];
  dateExpire?: Maybe<Scalars['DateTime']['output']>;
  dateStart?: Maybe<Scalars['DateTime']['output']>;
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  isStaff: Scalars['Boolean']['output'];
  org?: Maybe<Organization>;
  orgId: Scalars['UUID']['output'];
  orgUsersForOrgRole?: Maybe<Array<Maybe<UserOrganizationInOrganizationRole>>>;
  user?: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

export type UserInOrganizationFilterInput = {
  and?: InputMaybe<Array<UserInOrganizationFilterInput>>;
  claimPrefix?: InputMaybe<StringOperationFilterInput>;
  dateCreated?: InputMaybe<DateTimeOperationFilterInput>;
  dateExpire?: InputMaybe<DateTimeOperationFilterInput>;
  dateStart?: InputMaybe<DateTimeOperationFilterInput>;
  dateUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  displayOrder?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isStaff?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<UserInOrganizationFilterInput>>;
  org?: InputMaybe<OrganizationFilterInput>;
  orgId?: InputMaybe<UuidOperationFilterInput>;
  orgUsersForOrgRole?: InputMaybe<ListFilterInputTypeOfUserOrganizationInOrganizationRoleFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<UuidOperationFilterInput>;
};

/** Input model for UserInOrg */
export type UserInOrganizationInputModelInput = {
  /** Claim prefix */
  claimPrefix: Scalars['String']['input'];
  /** Date Expire */
  dateExpire?: InputMaybe<Scalars['DateTime']['input']>;
  /** Date Start */
  dateStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Display order */
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Is Staff */
  isStaff: Scalars['Boolean']['input'];
  orgId: Scalars['UUID']['input'];
  /** User Id */
  userId: Scalars['UUID']['input'];
};

export type UserInOrganizationSortInput = {
  claimPrefix?: InputMaybe<SortEnumType>;
  dateCreated?: InputMaybe<SortEnumType>;
  dateExpire?: InputMaybe<SortEnumType>;
  dateStart?: InputMaybe<SortEnumType>;
  dateUpdated?: InputMaybe<SortEnumType>;
  displayOrder?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isStaff?: InputMaybe<SortEnumType>;
  org?: InputMaybe<OrganizationSortInput>;
  orgId?: InputMaybe<SortEnumType>;
  user?: InputMaybe<UserSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

export type UserLogin = {
  id: Scalars['UUID']['output'];
  loginProvider?: Maybe<Scalars['String']['output']>;
  providerDisplayName?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

export type UserLoginFilterInput = {
  and?: InputMaybe<Array<UserLoginFilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  loginProvider?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserLoginFilterInput>>;
  providerDisplayName?: InputMaybe<StringOperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<UuidOperationFilterInput>;
};

export type UserLoginHistory = {
  authType?: Maybe<Scalars['String']['output']>;
  browserInformation?: Maybe<Scalars['String']['output']>;
  claimedUserName?: Maybe<Scalars['String']['output']>;
  event: Scalars['DateTime']['output'];
  gatewayIPAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isAuthenticated: Scalars['Boolean']['output'];
};

/** A connection to a list of items. */
export type UserLoginHistoryByUserIdConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<UserLoginHistoryByUserIdEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserLoginHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserLoginHistoryByUserIdEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserLoginHistory;
};

/** A connection to a list of items. */
export type UserLoginHistoryConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<UserLoginHistoryEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserLoginHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserLoginHistoryEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserLoginHistory;
};

export type UserLoginHistoryFilterInput = {
  and?: InputMaybe<Array<UserLoginHistoryFilterInput>>;
  authType?: InputMaybe<StringOperationFilterInput>;
  browserInformation?: InputMaybe<StringOperationFilterInput>;
  claimedUserName?: InputMaybe<StringOperationFilterInput>;
  event?: InputMaybe<DateTimeOperationFilterInput>;
  gatewayIPAddress?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isAuthenticated?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<UserLoginHistoryFilterInput>>;
};

export type UserLoginHistorySortInput = {
  authType?: InputMaybe<SortEnumType>;
  browserInformation?: InputMaybe<SortEnumType>;
  claimedUserName?: InputMaybe<SortEnumType>;
  event?: InputMaybe<SortEnumType>;
  gatewayIPAddress?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isAuthenticated?: InputMaybe<SortEnumType>;
};

export type UserLoginSortInput = {
  id?: InputMaybe<SortEnumType>;
  loginProvider?: InputMaybe<SortEnumType>;
  providerDisplayName?: InputMaybe<SortEnumType>;
  user?: InputMaybe<UserSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

export type UserOrganizationInOrganizationRole = {
  applicationServiceId: Scalars['UUID']['output'];
  claimPrefix?: Maybe<Scalars['String']['output']>;
  dateCreated: Scalars['DateTime']['output'];
  dateExpire?: Maybe<Scalars['DateTime']['output']>;
  dateStart?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  orgId: Scalars['UUID']['output'];
  orgRole?: Maybe<OrganizationInRole>;
  roleOrgId: Scalars['UUID']['output'];
  userOrg?: Maybe<UserInOrganization>;
  userOrgId: Scalars['UUID']['output'];
};

export type UserOrganizationInOrganizationRoleFilterInput = {
  and?: InputMaybe<Array<UserOrganizationInOrganizationRoleFilterInput>>;
  applicationServiceId?: InputMaybe<UuidOperationFilterInput>;
  claimPrefix?: InputMaybe<StringOperationFilterInput>;
  dateCreated?: InputMaybe<DateTimeOperationFilterInput>;
  dateExpire?: InputMaybe<DateTimeOperationFilterInput>;
  dateStart?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<UserOrganizationInOrganizationRoleFilterInput>>;
  orgId?: InputMaybe<UuidOperationFilterInput>;
  orgRole?: InputMaybe<OrganizationInRoleFilterInput>;
  roleOrgId?: InputMaybe<UuidOperationFilterInput>;
  userOrg?: InputMaybe<UserInOrganizationFilterInput>;
  userOrgId?: InputMaybe<UuidOperationFilterInput>;
};

export type UserOrganizationInOrganizationRoleSortInput = {
  applicationServiceId?: InputMaybe<SortEnumType>;
  claimPrefix?: InputMaybe<SortEnumType>;
  dateCreated?: InputMaybe<SortEnumType>;
  dateExpire?: InputMaybe<SortEnumType>;
  dateStart?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  orgId?: InputMaybe<SortEnumType>;
  orgRole?: InputMaybe<OrganizationInRoleSortInput>;
  roleOrgId?: InputMaybe<SortEnumType>;
  userOrg?: InputMaybe<UserInOrganizationSortInput>;
  userOrgId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type UserOrgsInOrgRolesConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<UserOrgsInOrgRolesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserOrganizationInOrganizationRole>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserOrgsInOrgRolesEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserOrganizationInOrganizationRole;
};

/** Input for UserOrgs In OrgRoles model */
export type UserOrgsInOrgRolesInputModelInput = {
  /** Gets or inits the application service id. */
  applicationServiceId: Scalars['UUID']['input'];
  /** Gets or inits the claim prefix. */
  claimPrefix?: InputMaybe<Scalars['String']['input']>;
  /** Gets or inits the date expire. */
  dateExpire?: InputMaybe<Scalars['DateTime']['input']>;
  /** Gets or inits the date start. */
  dateStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Gets or inits the org id. */
  orgId: Scalars['UUID']['input'];
  /** Gets or inits the role org id. */
  roleOrgId: Scalars['UUID']['input'];
  /** Gets or inits the user org id. */
  userOrgId: Scalars['UUID']['input'];
};

export type UserRole = {
  id: Scalars['UUID']['output'];
  role?: Maybe<Role>;
  roleId: Scalars['UUID']['output'];
  user?: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

export type UserSession = {
  created?: Maybe<Scalars['DateTime']['output']>;
  expires?: Maybe<Scalars['DateTime']['output']>;
  renewed?: Maybe<Scalars['DateTime']['output']>;
};

export type UserSessionsListResultsModel = {
  data?: Maybe<Array<Maybe<UserSession>>>;
  id: Scalars['UUID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  meta: Array<KeyValuePairOfStringAndObject>;
  status: Scalars['Int']['output'];
  unhandledException?: Maybe<Scalars['String']['output']>;
};

export type UserSortInput = {
  accessFailedCount?: InputMaybe<SortEnumType>;
  concurrencyStamp?: InputMaybe<SortEnumType>;
  dateUpdated?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  emailConfirmed?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  howWasThisRecordCreated?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isPasswordExpired?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  lockoutEnabled?: InputMaybe<SortEnumType>;
  lockoutEnd?: InputMaybe<SortEnumType>;
  normalizedEmail?: InputMaybe<SortEnumType>;
  normalizedUserName?: InputMaybe<SortEnumType>;
  password?: InputMaybe<SortEnumType>;
  phoneExtension?: InputMaybe<SortEnumType>;
  phoneNumber?: InputMaybe<SortEnumType>;
  phoneNumberConfirmed?: InputMaybe<SortEnumType>;
  prefix?: InputMaybe<SortEnumType>;
  primaryIdentifierNumber?: InputMaybe<SortEnumType>;
  securityStamp?: InputMaybe<SortEnumType>;
  selectedRecoveryAvatar?: InputMaybe<SortEnumType>;
  suffix?: InputMaybe<SortEnumType>;
  twoFactorEnabled?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
};

export type UserToken = {
  id: Scalars['UUID']['output'];
  loginProvider: Scalars['String']['output'];
  name: Scalars['String']['output'];
  user?: Maybe<User>;
  userId: Scalars['UUID']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** The user update input model. */
export type UserUpdateInputModelInput = {
  /** Gets or sets the email. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Gets or sets the first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Gets or sets the last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Gets or sets the phone number. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Gets or sets the name prefix. */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /** Gets or sets the name suffix. */
  suffix?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type UsersByConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<UsersByEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UsersByEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: User;
};

/** A connection to a list of items. */
export type UsersConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<UsersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UsersEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: User;
};

/** A connection to a list of items. */
export type UsersInOrganizationsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<UsersInOrganizationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserInOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UsersInOrganizationsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserInOrganization;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};
